import {connect, MapDispatchToProps, MapStateToProps} from "react-redux";
import {PopupDialog, PopupDialogDispatchProps, PopupDialogStateProps} from "./PopupDialog";
import {State} from "../../store/rootReducers";
import {selectPopup} from "../../selectors/popup";
import {popupDelete} from "../../ducks/popup";
import {updateTechReportText} from "../../ducks/upload";
import {selectTechReportText} from "../../selectors/upload";

const mapStateToProps: MapStateToProps<PopupDialogStateProps,
    {},
    State> = state => {
    const {popups} = selectPopup(state);
    const reportText = selectTechReportText(state);

    return {
        popups,
        reportText,
    };
};

const dispatchProps: MapDispatchToProps<PopupDialogDispatchProps, {}> = {
    onPopupDelete: popupDelete,
    updateTechReportText,
};

export const PopupDialogConnected = connect(
    mapStateToProps,
    dispatchProps
)(PopupDialog);
